module.exports = __webpack_public_path__ + "static/media/file_type_other_icon.b2a96faa.svg";